import { DAY_NAMES, MONTH_NAMES } from './config';
import type { DayData } from './types';

export function formatDate(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00');
  return `${d.getDate()} ${MONTH_NAMES[d.getMonth()]}`;
}

export function dayName(dateStr: string): string {
  return DAY_NAMES[new Date(dateStr + 'T00:00:00').getDay()];
}

export function formatTime(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return h ? `${h}ч ${m}м` : `${m} мин`;
}

export function getWeekEnd(offset: number): string {
  const now = new Date();
  const day = now.getDay();
  const diffToMon = day === 0 ? -6 : 1 - day;

  if (offset === 0) {
    // Current week: end = today (show data up to now)
    return now.toISOString().slice(0, 10);
  }

  // Past/future weeks: end = Sunday of that week
  const d = new Date(now);
  d.setDate(d.getDate() + diffToMon + offset * 7 + 6);
  return d.toISOString().slice(0, 10);
}

export function deltaPercent(cur: number, prev: number): { pct: number; direction: 'up' | 'down' } | null {
  if (!prev || prev === 0) return null;
  const pct = Math.round((cur - prev) / prev * 100);
  if (pct === 0) return null;
  return { pct: Math.abs(pct), direction: pct > 0 ? 'up' : 'down' };
}

export function todayStr(): string {
  return new Date().toISOString().slice(0, 10);
}

/** Aggregate macros across days -- used by 5+ components */
export interface MacroTotals {
  calories: number;
  protein: number;
  fat: number;
  carbs: number;
  daysWithData: number;
}

export function sumMacros(days: DayData[]): MacroTotals {
  let calories = 0, protein = 0, fat = 0, carbs = 0, daysWithData = 0;
  for (const d of days) {
    calories += d.total || 0;
    if (d.total > 0) daysWithData++;
    for (const e of d.entries || []) {
      for (const i of e.items || []) {
        protein += i.protein || 0;
        fat += i.fat || 0;
        carbs += i.carbs || 0;
      }
    }
  }
  return { calories, protein, fat, carbs, daysWithData };
}
